import React, { useMemo, startTransition, useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { listedDaysFormatter, unixTimeStampToDate } from 'Utils/listingUtils'
import { formatDistanceStrict, formatDistanceToNowStrict } from 'date-fns'
import parseISO from 'date-fns/parseISO'
import isValid from 'date-fns/isValid'
import { BlurCont } from 'Layout'

const ListedAgo = (
  {
    entryDateUnix,
    entryDate,
    endDate,
    listingIsLocked,
    userIsAuthentificated,
  },
) => {
  const [marketOrSiteDays, setMarketOrSiteDays] = useState('site')
  // const marketOrSiteDays = userIsAuthentificated ? 'market' : 'site'
  useEffect(() => {
    startTransition(() => setMarketOrSiteDays(userIsAuthentificated ? 'market' : 'site'))
  }, [userIsAuthentificated])
  const listingEndAgo = useMemo(() => (
    isValid(new Date(endDate)) ?
      (
        <>
          <BlurCont blur={listingIsLocked}>
            {entryDate && endDate && formatDistanceStrict(new Date(entryDate), new Date(endDate), { unit: 'day' })}
          </BlurCont>&nbsp;on {marketOrSiteDays}
        </>) :
      entryDateUnix ? (
        <>
          <BlurCont blur={listingIsLocked}>
            {listedDaysFormatter(unixTimeStampToDate(entryDateUnix))}
          </BlurCont>&nbsp;on {marketOrSiteDays}
        </>) : isValid(new Date(entryDate)) ? (
          <>
            <BlurCont blur={listingIsLocked}>
              {entryDate && formatDistanceToNowStrict(parseISO(entryDate), { unit: 'day' })}
            </BlurCont>&nbsp;on {marketOrSiteDays}
          </>
      ) : ''
  ), [entryDate, entryDateUnix, endDate, listingIsLocked, marketOrSiteDays])
  if(listingEndAgo) return listingEndAgo
  return null
}


ListedAgo.propTypes = {
  entryDateUnix: PropTypes.number,
  entryDate: PropTypes.string,
  endDate: PropTypes.string,
  listingIsLocked: PropTypes.bool,
  userIsAuthentificated: PropTypes.bool,
}

export default ListedAgo
